import { CheckableFieldContext } from "./chunk-EYE6MH2Q.js";

// src/components/CheckableField/CheckableField.Wrap.tsx
import React, { useContext } from "react";
import clsx from "clsx";
var CheckableFieldWrap = _ref => {
  let {
    className,
    children
  } = _ref;
  const {
    id
  } = useContext(CheckableFieldContext);
  return (
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    /* @__PURE__ */
    React.createElement("label", {
      htmlFor: id,
      className: clsx("pd-checkable-field__wrap", className)
    }, children)
  );
};
var CheckableField_Wrap_default = CheckableFieldWrap;
export { CheckableField_Wrap_default };